import { createIcon } from '../createIcon';
import { ReactComponent as IconEye } from '../svg/eye.svg';

export default createIcon(IconEye);
